export const DISBURSEMENT_TYPE = {
  BALANCE_IN: 'BALANCE_IN',
  BALANCE_OUT: 'BALANCE_OUT',
}

export const DISBURSEMENT_STATUS = {
  PENDING: 'NEW',
  COMPLETED: 'COMPLETED',
  UNVERIFIED: 'UNVERIFIED',
}